import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

// Answering an offer only ever changes the state; the rest of the record is the server's.
const RESPONSE_ATTRIBUTES = ['state'];

export default class TaskAssignmentSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    if (snapshot.id) {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(data.data.attributes, RESPONSE_ATTRIBUTES);

      return data;
    }

    // The create endpoint takes the task and the assignee as relationships, where the rest of the
    // API keeps its identifiers. They live on the model as plain ids because that is all the index
    // payload gives back to match a teammate on.
    // @ts-expect-error - we have no typings for the json api
    data.data.relationships = {
      task: { data: { id: snapshot.attr('taskId') } },
      user: { data: { id: snapshot.attr('userId') } },
    };

    // @ts-expect-error - we have no typings for the json api
    delete data.data.attributes;

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'task-assignment': TaskAssignmentSerializer;
  }
}
